import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge6 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='相続税対象財産' fontWeight={700} />
                <p>
                    相続税は、亡くなった方の財産を相続により取得した場合、その取得した財産に対してかかるものです。
                    <br />
                    具体的には土地、借地権、建物、借家権、立木事業用資産、有価証券、貴金属、宝石、書画骨董、電話加入権、預貯金、ゴルフ会員権、現金等、お金に換えられる財産のことをいいます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権評価額の調べ方' fontWeight={700} />
                <p>
                    ゴルフ会員権には、社団法人制会員権、株主会員制会員権、預託金制会員権、プレー権会員権があります。
                    <br />
                    取引相場があるゴルフ会員権の相続評価については、売り価格と買い価格の間で決まる通常の取引価格70％で評価しますが、それ以外のものについてはそれぞれ評価が定められております。
                </p>

                <Heading3 title='取引相場のないもの' />
                <p>
                    １.ゴルフ会員権が株式の場合、ゴルフ会員権に係る株式について財産評価基本通達によって評価計算します。すなわち非上場株式の株式評価計算が適用されます。
                    <br />
                    ２.ゴルフ会員権の預託金等が、ゴルフ場の規約等に基づいて直ちに返還を受けることが出来る場合は、その預託金等の金額を加算します。
                    <br />
                    ３.ゴルフ会員権の預託金等の返還期間が１年以上があるものについては、返還を受けることが出来る日までの期間に応ずる基準年利率によって、複利現価の金額を加算します。
                    <br />
                    ４.譲渡出来ないゴルフ会員権で、返還を受けることが出来る預託金等が無いものは評価しません。
                    <br />
                    具体的な評価額の計算例については
                    <a href='/knowledge/34'>ゴルフ会員権の相続税評価・計算方法（具体例つき）</a>
                    で詳しくご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ケース別対応方法' fontWeight={700} />
                <p>
                    相続人が引き継いで利用する場合、ゴルフ会員権の相続手続きを行い、ゴルフ場の入会手続き、理事会承認の上、名義書換料・年会費等を支払い、手続きを完了させれば、メンバーとして利用出来ます。
                    <br />
                    相続して売却する場合、ゴルフ会員権を相続手続きの上、被相続人の除籍謄本、被相続人の戸籍謄本（全相続人の記載されている謄本）もしくは法定相続情報証明、各相続人の戸籍抄本、各相続人の印鑑登録証明書、同意書等を付けて売却します。
                    <br />
                    また、ゴルフ場によっては一旦名義人に名義書換をしてからでないと売却出来ない場合もありますのでその都度ゴルフ場か会員権業者に確認が必要となります。
                </p>

                <Heading3 title='法定相続情報証明制度とは' />
                <p>
                    亡くなった人の法定相続人（法律で定められた相続人）が誰で、各法定相続人は被相続人とそれぞれどのような間柄なのかという情報を証明するための制度です。
                    <br />
                    法定情報証明制度は2017年5月29日より開始されました。この制度が開始される以前は、相続手続きにおいて、相続情報を証明するために逐一戸籍謄本等の大量の書類が必要でした。
                    <br />
                    法定相続情報証明制度の手続きが済むと、認証文が付記された法定相続情報一覧図の写しが何通でも無料で交付されます。
                    <br />
                    法定相続情報一覧図とは、法定相続人が誰で各法定相続人は被相続人とそれぞれどのような間柄なのかという情報を一覧化した図のことです。
                    <br />
                    この法定相続情報一覧図の写しが、従来の戸籍謄本等の大量の書類の代わりに、法定相続情報を証明してくれるので、相続手続きを円滑に進めることが可能になりました。
                    <br />
                    <br />
                    <strong>
                        <u>※法定相続情報証明制度に関する手続きの流れ</u>
                    </strong>
                    <br />
                    必要書類には、必ず必要となる物と、場合によっては必要になる物があります。
                    <br />
                    【必ず用意する書類】
                    <br />
                    ・被相続人の戸籍謄本と除籍謄本
                    <br />
                    ・被相続人の住民票の除票
                    <br />
                    ・各相続人の戸籍謄本または戸籍抄本
                    <br />
                    ・申出人の氏名と住所を確認できる公的書類
                    <br />
                    ※戸籍謄本、除籍謄本、戸籍抄本は、本籍地の役所で取得することが出来ます。
                    <br />
                    ※住民票の除票は被相続人の最後の住所地の役所で取得することが出来ます。
                    <br />
                    <br />
                    <strong>
                        <u>※法定相続情報一覧図の作成</u>
                    </strong>
                    <br />
                    法定相続情報一覧図は、被相続人と法定相続人全員の関係が分かるように記載します。
                    <br />
                    相続放棄をした人や、相続欠格の人、資産分割協議の結果、相続しなかった法定相続人も記載しますが相続放棄した場合や、資産分割の結果相続しなかったなど、そのような事情については記載しません。
                    <br />
                    申出を行う登記所は、次のうちいずれかの登記所を選択することができます。
                    <br />
                    ・被相続人の死亡時の本籍地
                    <br />
                    ・被相続人の最後の住所地
                    <br />
                    ・申出人の住所地
                    <br />
                    ・被相続人名義の不動産の所在地
                    <br />
                    申出書に上述の必要書類と法定相続情報一覧図を添付して提出します。
                    <br />
                    また、申出が受理されると一覧図の交付予定日を知らせる書類が渡されます。
                    <br />
                    交付までの期間は登記所によってそれぞれ異なりますが、一般的には数日から数週間かかります。交付日には、提出した戸籍謄本関係一式が返却され、登記官が認証した旨の文言が付された法定相続情報一覧図の写しが必要な枚数交付されます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='譲渡所得について' fontWeight={700} />
                <p>
                    売却の際、譲渡益が出る場合は譲渡所得になります。
                    <br />
                    保有期間が5年を超えているものは長期譲渡所得、5年以内のものは短期譲渡所得として課税されます。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='計算式' fontWeight={700} />

                <Heading3 title='ゴルフ会員権保有期間5年超（長期譲渡）' />
                <p>
                    （売却金額－取得金額（被相続人の購入金額、名義変更料）－譲渡経費－特別控除（50万円））×1/2＝長期譲渡所得
                    <br />
                    ※他の所得と合わせて総合課税になります。
                </p>

                <Heading3 title='ゴルフ会員権保有期間5年以内（短期譲渡）' />
                <p>
                    売却金額－取得金額（被相続人の購入金額、名義変更料）－譲渡経費－特別控除（50万円）＝短期譲渡所得
                    <br />
                    ※他の所得と合わせて総合課税になります。
                </p>

                <Heading3 title='相続放棄について' />
                <p>個別の相続放棄はできず、すべて相続するか、すべて放棄するかのいずれになります。</p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権の相続税の評価方法、売却時の必要書類、譲渡所得について今回ご案内させて頂きました。
                    <br />
                    ただし、専門家による判断が必要な場合もございます。
                    <br />
                    内容についてのご質問や疑問点等ございましたら、当社までお気軽にお問合せください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge6;
